import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface FooterData {
  logoUrl: string | null;
  tagLine: string;
  socialLinks: Array<{ name: string; link: string }>;
  supportLogos: Array<{ url: string; link: string }>;
}

export interface FooterState {
  data: FooterData;
  isLoading: boolean;
  lastUpdated: Date | null;
  error: string | null;
}

const initialState: FooterState = {
  data: {
    logoUrl: null,
    tagLine: '',
    socialLinks: [],
    supportLogos: []
  },
  isLoading: false,
  lastUpdated: null,
  error: null
};

@Injectable({
  providedIn: 'root'
})
export class FooterStore {
  private stateSubject = new BehaviorSubject<FooterState>(initialState);
  public state$ = this.stateSubject.asObservable();

  constructor() {
    console.log('🏪 FooterStore initialized with default state');
  }

  /**
   * Get current footer state
   */
  getCurrentState(): FooterState {
    return this.stateSubject.value;
  }

  /**
   * Get current footer data
   */
  getCurrentData(): FooterData {
    return this.stateSubject.value.data;
  }

  /**
   * Update footer data
   */
  updateData(data: Partial<FooterData>): void {
    const currentState = this.stateSubject.value;
    this.stateSubject.next({
      ...currentState,
      data: {
        ...currentState.data,
        ...data
      },
      lastUpdated: new Date(),
      error: null
    });
  }

  /**
   * Set loading state
   */
  setLoading(isLoading: boolean): void {
    const currentState = this.stateSubject.value;
    this.stateSubject.next({
      ...currentState,
      isLoading
    });
  }

  /**
   * Set error state
   */
  setError(error: string | null): void {
    const currentState = this.stateSubject.value;
    this.stateSubject.next({
      ...currentState,
      error,
      isLoading: false
    });
  }

  /**
   * Reset to initial state
   */
  reset(): void {
    this.stateSubject.next(initialState);
  }
}

